import cn from "classnames";
import { Button } from "components/Button/Button";
import { useEffect, useState } from "react";
import { disableCopyPasteHandlers, disableGrammarlyExtension } from "utils/helper";
import { storage } from "services/storage";
import { ORGANIZATIONS } from "constant";
import { Editor } from "@tinymce/tinymce-react";
import { useIsMobileDevice } from "utils/hooks";
import { useLanguageContext } from "store/LanguageProvider";


export const FreeText = ({ onSubmit, time, questionId }) => {

  const organization = storage.get.org();
  const wizrFlag = organization === ORGANIZATIONS.WIZR;

  const { language } = useLanguageContext();

  const [saveEditorTimer, setSaveEditorTimer] = useState(0);
  const [inputValue, setInputValue] = useState("");
  const [minLengthError, setMinLengthError] = useState(false);
  const [loading, setLoading] = useState(false)

  const isMobile = useIsMobileDevice()

  const submitHandler = (forceSubmit = false) => {
    const checkAnswerMinLength = inputValue.trim().length >= 10;
    if (!checkAnswerMinLength) {
      setMinLengthError(true);
      if (!forceSubmit) return;
    } else setMinLengthError(false);
    setLoading(true)
    onSubmit({ answerText: inputValue.trim() }, true, false, true);
  };

  useEffect(() => {
    if (time !== null && time === 0) {
      submitHandler(true);
    }
  }, [time]);

  // Check FT_Cache for questionid and saved text for editor
  useEffect(() => {
    const freeTextAnswerCache = storage.get.freeTextCache() ?? {};
    if (freeTextAnswerCache[questionId]) setInputValue(freeTextAnswerCache[questionId])
  }, []);

  const handleEditorLocalStorageSave = () => {
    let tempFreeTextAnswerCache = storage.get.freeTextCache() ?? {};
    tempFreeTextAnswerCache[questionId] = inputValue;
    storage.set.freeTextCache(tempFreeTextAnswerCache)
  }

  // Timer for keeping track of editor changes
  useEffect(() => {
    let editorSaveInterval = setInterval(() => {
      setSaveEditorTimer(prev => prev + 1)
    }, 1000);

    return () => clearInterval(editorSaveInterval)
  }, []);

  // Saving content in LS cache every 20 seconds
  useEffect(() => {
    if (saveEditorTimer % 20 === 0) {
      handleEditorLocalStorageSave();
    }
  }, [saveEditorTimer])

  return (
    <div className={`flex flex-1 w-full flex-col items-center justify-between ${isMobile ? "pb-[52px]" : ""}`}>
      <div className={`w-full flex ${isMobile ? "justify-center fixed bottom-0 left-0 bg-[#fff] pt-1" : "justify-end sticky top-0 bg-[#fff]"} z-[3] p-[2px] mb-[2px]`}>
        <Button
          disabled={!inputValue || loading}
          onClick={(e) => submitHandler(false)}
          className="bg-cocoa-brown text-white"
        >
          Submit
        </Button>
      </div>
      <Editor
        tinymceScriptSrc={'/tinymce/tinymce.min.js'}
        id={"free-text-input"}
        value={inputValue}
        onEditorChange={(content, editor) => {
          disableGrammarlyExtension();
          if (minLengthError) setMinLengthError(false);
          setInputValue(content);
        }}
        init={{
          min_height: 500,
          max_height: 500,
          width: '100%',
          force_br_newlines: true,
          menubar: false,
          statusbar: false,
          content_css: '/tinyMceContent.css',
          plugins: 'link image code autoresize lists table',
          toolbar:
            'formatselect | bold italic underline | blocks | bullist numlist outdent indent',
          mobile: {
            toolbar_mode: "wrap",
          },
          language: language
        }}
        {...disableCopyPasteHandlers}
      />
      {
        minLengthError &&
        <p className="text-xl text-center text-red-500">Please add more than 10 characters.</p>
      }
    </div>
  );
};
